<div class="account-options">
  @if (!whiteLabel) {
    <app-logo class="bg-dark"></app-logo>
  }
  <div class="img-container">
    @if (provider) {
      <img class="providerImage" [src]="provider.header ? provider.header : provider.registrationSelectorImage" />
    }
  </div>
  <p class="validationText">{{ 'registration_personal_data' | locale }}</p>
  @if (loadedFields) {
    <form [formGroup]="dataFormGroup" class="form-group">
      <div
        class="content"
        appScrollHint
        [scrollHintEnabled]="showScrollHint"
        [hintBottom]="scrollHintConfig.bottom"
        [hintLeft]="scrollHintConfig.left"
        [hintWidth]="scrollHintConfig.width"
      >
        @if (providerLanguages && providerLanguages.length > 1) {
          <mat-label class="input-label">{{
            (isSelectedLanguageDifferentFromLocale ? 'consultation_language' : 'language') | locale
          }}</mat-label>
          <mat-form-field appearance="outline">
            <mat-select (selectionChange)="onLocaleChanged()" [(value)]="selectedLanguage">
              @for (language of providerLanguages; track language) {
                <mat-option [value]="language">
                  {{ language.name }}
                </mat-option>
              }
            </mat-select>
            <mat-icon matSuffix class="south">south</mat-icon>
          </mat-form-field>
        }

        @if (needsValidateName) {
          <mat-label class="input-label">{{ 'name_and_surname' | locale }}</mat-label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="name" type="text" />
            <mat-error>{{ 'name' | errorMessage: dataFormGroup }}</mat-error>
          </mat-form-field>
        }

        @if (requiredFields.includes('email')) {
          <mat-label class="input-label">{{ 'email' | locale }}</mat-label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="email" type="email" />
            <mat-error>{{ 'email' | errorMessage: dataFormGroup }}</mat-error>
          </mat-form-field>
        } @else if (requiredFields.includes('emailLAD')) {
          <mat-label class="input-label">{{ 'email' | locale }}</mat-label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="emailLAD" type="email" />
            <mat-error>{{ 'emailLAD' | errorMessage: dataFormGroup }}</mat-error>
          </mat-form-field>
        }

        @if (areDocumentTypeAndNumberRequiredFields) {
          <div class="document-fields">
            <div class="document-type-container">
              <mat-label class="input-label">{{ 'data_validation_document_type_label' | locale }}</mat-label>
              <mat-form-field>
                <mat-select
                  formControlName="documentTypeLAD"
                  [placeholder]="'filter_select' | locale"
                  [compareWith]="compareWithDocumentTypeFn"
                >
                  @for (documentType of documentTypes; track documentType) {
                    <mat-option [value]="documentType.value">{{ documentType.text | locale }} </mat-option>
                  }
                </mat-select>
                <mat-icon matSuffix>south</mat-icon>
              </mat-form-field>
            </div>

            <div class="document-number-container">
              <mat-label class="input-label">{{ 'data_validation_document_number_label' | locale }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="documentNumberLAD" type="email" />
                <mat-error>{{ 'documentNumberLAD' | errorMessage: dataFormGroup }}</mat-error>
              </mat-form-field>
            </div>
          </div>
          <span class="passport-required">{{ 'data_validation_passport_required_text' | locale }}</span>
        }

        <mat-label class="input-label">{{ 'birthDate' | locale }}</mat-label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="birthDate" [matDatepicker]="picker" [max]="maximumDate" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error>{{ 'birthDate' | errorMessage: dataFormGroup }}</mat-error>
        </mat-form-field>

        <mat-label class="input-label">{{ 'phone' | locale }}</mat-label>
        <ngx-material-intl-tel-input
          class="phone-input-data-validation"
          [fieldControl]="mobilePhone"
          [autoIpLookup]="false"
          [enableSearch]="false"
          [preferredCountries]="preferredCountries"
          [autoSelectedCountry]="selectedCountry"
          [iconMakeCall]="false"
          [textLabels]="textLabelsPhone"
        >
        </ngx-material-intl-tel-input>

        <mat-label class="input-label">{{ 'gender' | locale }}</mat-label>
        <mat-form-field appearance="outline">
          <mat-select formControlName="gender">
            @for (gender of genders; track gender) {
              <mat-option [value]="gender.value">{{ gender.name | locale }} </mat-option>
            }
          </mat-select>
          <mat-icon matSuffix class="south">south</mat-icon>
          <mat-error>{{ 'gender' | errorMessage: dataFormGroup }}</mat-error>
        </mat-form-field>

        @if (showCUILField) {
          <mat-label class="input-label">{{ 'data_validation_cuil_label' | locale }}</mat-label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="cuil" placeholder="CUIL" />
            <mat-hint>{{ 'data_validation_cuil_hint' | locale }}</mat-hint>
            <mat-error>
              @if (cuil.hasError('invalidFormat')) {
                {{ 'data_validation_cuil_invalid_format' | locale }}
              } @else if (cuil.hasError('invalidPrefix')) {
                {{ 'data_validation_cuil_invalid_prefix' | locale }}
              } @else if (cuil.hasError('documentMismatch')) {
                {{ 'data_validation_cuil_mismatch' | locale }}
              } @else {
                {{ 'cuil' | errorMessage: dataFormGroup }}
              }
            </mat-error>
          </mat-form-field>
        }
      </div>

      <div class="actions">
        <button mat-flat-button color="primary" [disabled]="!dataFormGroup.valid" (click)="continue()">
          {{ 'continue' | locale }}
          <mat-icon iconPositionEnd svgIcon="east"></mat-icon>
        </button>
      </div>
    </form>
  }
</div>
